<template>
	<b-container fluid>
		<page-title><h2 v-if="item"><router-link :to="{ name: 'CustomerList' }" class="nav-link">Klienci</router-link>/Edycja</h2></page-title>
      
    <div class="col page-element">
      <div v-if="updated" class="alert alert-success" role="status">Klient {{ updated.fullName }} został zapisany.</div>
      <alert-loading v-if="retrieveLoading || updateLoading"></alert-loading>
      <div v-if="retrieveError" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ retrieveError }}</div>
      <div v-if="updateError" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ updateError }}</div>
      <div v-if="deleteError" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ deleteError }}</div>

      <CustomerForm v-if="item && !retrieveLoading && !updateLoading" :handle-submit="update" :values="item" :errors="violations" :initialValues="retrieved"></CustomerForm>
    </div>
	</b-container>
</template>

<script>
  import CustomerForm from './Form.vue';
  import { mapGetters } from 'vuex';

  export default {
    created () {
      this.$store.dispatch('customer/update/retrieve', this.$route.params.id);
    },
    components: {
      CustomerForm
    },
    computed: {
      ...mapGetters({
        retrieveError: 'customer/update/retrieveError',
        retrieveLoading: 'customer/update/retrieveLoading',
        updateError: 'customer/update/updateError',
        updateLoading: 'customer/update/updateLoading',
        deleteError: 'customer/del/error',
        deleteLoading: 'customer/del/loading',
        deleted: 'customer/del/deleted',
        retrieved: 'customer/update/retrieved',
        updated: 'customer/update/updated',
        violations: 'customer/update/violations'
      })
    },
    data: function() {
      return {
        item: {}
      }
    },
    methods: {
      update (values) {
        this.$store.dispatch('customer/update/update', {item: this.retrieved, values: values });
      },
      del () {
        if (window.confirm('Czy na pewno chce usunąć tego klienta?'))
          this.$store.dispatch('customer/del/delete', this.retrieved);
      },
      reset () {
        this.$store.dispatch('customer/update/reset');
        this.$store.dispatch('customer/del/reset');
        this.$store.dispatch('customer/create/reset');
      }
    },
    watch: {
      deleted: function (deleted) {
        if (deleted) {
          this.$router.push({ name: 'CustomerList' });
        }
      }
    },
    beforeDestroy() {
      this.reset();
    }
  }
</script>



// WEBPACK FOOTER //
// Update.vue?dd31851a